import { AuthConsumerRenderProps, withAuthContext } from 'auth/AuthContext';
import { CancelTokenSource } from 'axios';
import InvoiceStatisticOptionsSegment
  from 'components/billing/invoice-statistic/segments/InvoiceStatisticOptionsSegment';
import InvoiceStatisticTableSegment from 'components/billing/invoice-statistic/segments/InvoiceStatisticTableSegment';
import PraxStyledSegment from 'components/layout/PraxStyledSegment';
import StyledErrorMessage from 'components/layout/StyledErrorMessage';
import moment from 'moment';
import React, { Component } from "react";
import { MessageSourceProps, withMessages } from "react-message-source";
import { RouterProps } from 'react-router';
import { Divider } from 'semantic-ui-react';
import axios from 'services/http';
import styled from 'styled-components';
import { InvoiceStatisticData, InvoiceStatisticRequest } from 'ts-types/api.types';

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

interface Props extends AuthConsumerRenderProps, MessageSourceProps, RouterProps {
}

interface State {
  invoiceStatisticData: Partial<InvoiceStatisticData>[],
  dataLoading: boolean,
  formData: InvoiceStatisticRequest,
  errorMessage?: string,
  cancelTokenSource: CancelTokenSource
}

class InvoiceStatisticView extends Component<Props, State> {

  constructor(props: Props) {
    super(props);

    const cancelTokenSource = axios.CancelToken.source();

    this.state = {
      invoiceStatisticData: [],
      dataLoading: false,
      formData: this.initialFormDataValues(),
      cancelTokenSource: cancelTokenSource
    };

  }

  initialInvoiceStatisticDataValues = (): Partial<InvoiceStatisticData>[] => {
    const invoiceStatisticData = {
      totalOpenByTreatmentDate: undefined,
      totalByTreatmentDate: undefined,
      totalByBillDate: undefined,
      totalByPaymentDate: undefined,
      totalByStornoDate: undefined
    };

    return [invoiceStatisticData];
  };

  initialFormDataValues = (): InvoiceStatisticRequest => {

    const {currentUser} = this.props;

    const fromDate = moment().startOf('month').format("YYYY-MM-DD");
    const toDate = moment().endOf('month').format("YYYY-MM-DD");

    return {
      mandateId: currentUser ? currentUser.userConfig.mandateId : 1,
      fromDate: fromDate,
      toDate: toDate,
      byTreatmentDate: true,
      openByTreatmentDate: true,
      byBillDate: true,
      byPaymentDate: true,
      byStornoDate: true
    }
  };

  setFormDataValues = (formData: InvoiceStatisticRequest): void => {
    this.setState({
      formData: formData
    });
  }

  setErrorMessage = (errorMessage?: string) => {
    this.setState({
      errorMessage: errorMessage
    });
  };

  onFilterInvoiceStatisticData = (invoiceStatisticData: InvoiceStatisticData[]) => {
    this.setState({
      invoiceStatisticData: invoiceStatisticData
    })
  };

  onInvoiceStatisticLoadingChange = (dataLoading: boolean) => {
    this.setState({
      dataLoading: dataLoading
    })
  };

  render(): React.ReactElement {

    const {
      invoiceStatisticData,
      formData,
      dataLoading,
      errorMessage
    } = this.state;

    return (
        <PraxStyledSegment>
          <StyledContainer>
            {errorMessage
            && (
                <StyledErrorMessage onDismiss={() => this.setErrorMessage()} style={{margin: 0}}>
                  {errorMessage}
                </StyledErrorMessage>
            )
            }
            <InvoiceStatisticOptionsSegment
                onFilterInvoiceStatisticData={this.onFilterInvoiceStatisticData}
                onInvoiceStatisticLoadingChange={this.onInvoiceStatisticLoadingChange}
                setFormDataValues={this.setFormDataValues}
                setErrorMessage={this.setErrorMessage}
            />
            <Divider/>
            <InvoiceStatisticTableSegment
                invoiceStatisticData={invoiceStatisticData}
                fromDate={formData.fromDate}
                toDate={formData.toDate}
                dataLoading={dataLoading}
                setErrorMessage={this.setErrorMessage}
            />
          </StyledContainer>
        </PraxStyledSegment>
    );
  }

}

export default withAuthContext(withMessages(InvoiceStatisticView));
